import React from 'react';
import { ButtonView } from '@vivli/shared/views';
import { DTIAMRCommonConst } from '@vivli/shared/infrastructure/constants';

interface DataPackageValidateButtonProps {
    onClick: () => void;
    style?: React.CSSProperties;
    title?: string;
}

export const DataPackageValidateButtonView = (props: DataPackageValidateButtonProps) => {
    const { onClick, style, title } = props;

    return (
        <div style={style}>
            <ButtonView
                onClick={onClick}
                dataId={DTIAMRCommonConst.VerifyUpload}
                style={{ margin: 0 }}
                title={
                    title ||
                    '"Verify Upload" will confirm that for each of the files listed below, the file itself has been fully uploaded and is stored in the system.'
                }
            >
                Verify Upload
            </ButtonView>
        </div>
    );
};
